import { render, staticRenderFns } from "./sxindex.vue?vue&type=template&id=2695e2f6&scoped=true"
import script from "./sxindex.vue?vue&type=script&lang=js"
export * from "./sxindex.vue?vue&type=script&lang=js"
import style0 from "./sxindex.vue?vue&type=style&index=0&id=2695e2f6&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2695e2f6",
  null
  
)

export default component.exports